import type { DeviationSeverityFE } from 'domain/vehicle';

import styles from './styles/SeverityBadge.module.scss';

interface Props {
    severity: DeviationSeverityFE;
}

const SeverityBadge = ({ severity }: Props) => {
    switch (severity) {
        case 'FATAL':
            return (
                <span
                    data-testid='severity-badge'
                    className={`${styles.SeverityBadge} ${styles['SeverityBadge--fatal']} rioglyph rioglyph-remove-sign`}
                />
            );
        case 'ERROR':
            return (
                <span
                    data-testid='severity-badge'
                    className={`${styles.SeverityBadge} ${styles['SeverityBadge--error']} rioglyph rioglyph-error-sign`}
                />
            );
        case 'WARNING':
            return (
                <span
                    data-testid='severity-badge'
                    className={`${styles.SeverityBadge} ${styles['SeverityBadge--warning']} rioglyph rioglyph-warning-sign`}
                />
            );
        default:
            return null;
    }
};

export default SeverityBadge;
